module.exports = __webpack_public_path__ + "img/logo.068e70d6.svg";